import React, { useEffect, useState, useCallback } from "react";
import {
  FormControl,
  FormLabel,
  Grid,
  TextField,
} from "@material-ui/core";
import { useForm } from "hooks/useForm";
import RegularButton from "components/CustomButtons/Button";
import { fieldValidations, initialValues } from "./inputValues";
import { useDispatch, useSelector } from "react-redux";
import { editUser, newUser, unselectUser } from "redux/actions/users/usersActions";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { animations } from "helpers/animations";
import { blue, green, red } from "@mui/material/colors";
import { useToggle } from "hooks/useToggle";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { UserPermissionsSelector } from "components/UserPermissions/UserPermissionsSelector";

const style = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const god = 'ADMIN_GOD'

export const UserForm = ({onClose=null}) => {
  const { stationsList, stationsGod, companiesList, companiesGod } = useSelector(({ companies }) => companies);
  const { username:loginUsername, rules:loginRules, id:idUser } = useSelector(({ login }) => login);
  const isGod = loginRules.includes(god)
  const { rules, user, isEdit, users } = useSelector(({ users }) => users);
  const dispatch = useDispatch();
  const hist = useHistory();
  const { printers } = useSelector(({ printers }) => printers);
  const [isPassword, setIsPassword] = useState(true);
  const [showPass, setShowPass] = useToggle();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const [BLOCK_EDIT, setBLOCK_EDIT] = useState(false)
  const {
    inputValues,
    handleInputOnChange,
    runValidates,
    handleNewValues,
    fieldErrors,
  } = useForm(initialValues, fieldValidations);
  const {
    name,
    username,
    email,
    password,
    confirmPass,
    stationsSelected,
    rulesSelected,
    printersSelected,
  } = inputValues;

  const handleStationsChange = useCallback((stations) => {
    if (stations && Array.isArray(stations)) {
      handleNewValues({...inputValues, stationsSelected: stations});
    }
  }, [inputValues, handleNewValues]);

  const handleRulesChange = useCallback((rules) => {
    if (rules && Array.isArray(rules)) {
      handleNewValues({...inputValues, rulesSelected: rules});
    }
  }, [inputValues, handleNewValues]);

  const handlePrinterChange = useCallback((printer) => {
    handleNewValues({...inputValues, printersSelected: printer?.id || ''});
  }, [inputValues, handleNewValues]);

  const handleSubmit = (e) => {
    const {
      stationsSelected,
      rulesSelected,
      printersSelected,
      ...rest
    } = inputValues;

    const printS = printers.find(pr => pr.id === printersSelected)
    const form = {
      ...rest,
      stations: stationsSelected.map((sta) => sta.id),
      rules: rulesSelected.map((rl) => rl.id),
      config: {
        printer: printersSelected ? printS : null,
      },
      updateLogin: idUser === user.id ? true : false
    };
    e.preventDefault();
    if (isEdit) {
      if (runValidates(["password", "confirmPass"])) return;
      dispatch(editUser(user.id, form, handleNav));
      return;
    } else if (runValidates()) return;
    const newUserForm = {
      name,
      username,
      email,
      password,
    };
    dispatch(newUser(newUserForm, onClose));
    return;
  };

  const handleNav = () => {
    hist.push("/admin/usuarios_menu");
    dispatch(unselectUser());
  };


  useEffect(() => {
    if(user.username === loginUsername && !isGod){
      setBLOCK_EDIT(true)
    }
    if (isEdit) {
      const rulesF = rules?.filter(
        (rule) =>
          user.rules.includes(rule.label) || user.rules.includes(rule.id)
      );

      let stationsS  
      if(isGod){
        stationsS = stationsGod.filter(st => user.stations.includes(st.id))
      }else{
        stationsS = stationsList.filter(st => user.stations.includes(st.id))
      }
      const printerS = user.config.printer
      handleNewValues({
        username: user.username,
        name: user.name,
        email: user.email,
        stationsSelected: stationsS,
        rulesSelected: rulesF,
        printersSelected: printerS ? printerS.id : '',
      });
    }

    users.length === 0 && handleNav()
  }, []);

  useEffect(() => {
    if (!isEdit) {
      if (password.length > 3 && confirmPass.length > 3) {
        password === confirmPass ? setIsPassword(false) : setIsPassword(true);
      }
    }
  }, [password, confirmPass]);

  return (
    <>
      <FormControl fullWidth>
        <FormLabel style={{
          textAlign: 'end', marginBottom: 16, color: red[400]
        }}>{ BLOCK_EDIT ? 'No es posible asignarte a ti mismo 🚫 [ Estaciones, Reglas, Impresoras ] 🚫 - Contacta a un Administrador' : '' }</FormLabel>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              label="Nombre"
              name="name"
              value={name}
              variant="outlined"
              fullWidth
              required={true}
              error={fieldErrors.name}
              helperText={fieldErrors.name || ""}
              onChange={handleInputOnChange}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Nombre De Usuario"
              name="username"
              value={username}
              variant="outlined"
              fullWidth
              required={true}
              error={fieldErrors.username}
              helperText={fieldErrors.username || ""}
              onChange={handleInputOnChange}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Correo Electronico"
              name="email"
              value={email}
              variant="outlined"
              fullWidth
              required={true}
              error={fieldErrors.email}
              helperText={fieldErrors.email || ""}
              onChange={handleInputOnChange}
            />
          </Grid>
          {!isEdit && (
            <>
              <Grid item xs={12}>
                <TextField
                  label="Contraseña"
                  name="password"
                  type={showPass ? "text" : "password"}
                  value={password}
                  variant="outlined"
                  fullWidth
                  required={true}
                  error={fieldErrors.password}
                  helperText={fieldErrors.password || ""}
                  onChange={handleInputOnChange}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Confirmar contraseña"
                  name="confirmPass"
                  type={showPass ? "text" : "password"}
                  value={confirmPass}
                  variant="outlined"
                  fullWidth
                  required={true}
                  error={fieldErrors.confirmPass}
                  helperText={fieldErrors.confirmPass || ""}
                  onChange={handleInputOnChange}
                  InputProps={{
                    endAdornment: (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <RegularButton
                          justIcon
                          round
                          tooltip={
                            showPass
                              ? "Ocultar contraseña"
                              : "Mostrar contraseña"
                          }
                          color="transparent"
                          onClick={setShowPass}
                        >
                          {showPass ? (
                            <VisibilityIcon
                              className={animations.fadeIn}
                              style={{ color: green[300] }}
                            />
                          ) : (
                            <VisibilityOffIcon
                              className={animations.fadeIn}
                              style={{ color: green[500] }}
                              onClick={setShowPass}
                            />
                          )}
                        </RegularButton>
                        {isPassword ? (
                          <LockOpenIcon
                            className={animations.fadeIn}
                            style={{ color: blue[500] }}
                          />
                        ) : (
                          <LockIcon
                            className={animations.fadeIn}
                            style={{ color: blue[700] }}
                          />
                        )}
                      </div>
                    ),
                  }}
                />
              </Grid>
            </>
          )}

          {isEdit && (
            <>
              <Grid item xs={12}>
                <UserPermissionsSelector
                  stations={isGod ? stationsGod : stationsList}
                  companies={isGod ? companiesGod : companiesList || []}
                  rules={rules}
                  printers={printers}
                  selectedStations={stationsSelected}
                  selectedRules={rulesSelected}
                  selectedPrinter={printers.find(p => p.id === printersSelected) || null}
                  onStationsChange={handleStationsChange}
                  onRulesChange={handleRulesChange}
                  onPrinterChange={handlePrinterChange}
                  disabled={BLOCK_EDIT}
                />
              </Grid>
            </>
          )}
          <Grid
            item
            xs={12}
            style={{
              ...style,
              justifyContent: "flex-end",
              gap: 15,
              flexWrap: "wrap",
              marginTop: 40
            }}
          >
            <RegularButton
              color="danger"
              onClick={ onClose ? onClose : handleNav}
              disabled={isLoadingComp?.loadingUserEdit}
            >
             { onClose ? 'Cancelar' : 'Volver'  }
            </RegularButton>
            <RegularButton
              color="info"
              onClick={handleSubmit}
              loading={isLoadingComp?.loadingUserEdit}
            >
              { isEdit ? 'Actualizar' : 'Crear'  }
            </RegularButton>
          </Grid>
        </Grid>
      </FormControl>
    </>
  );
};
